import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Autocomplete, Box, Button, DialogActions, DialogContent, DialogContentText, FormControl, FormHelperText, IconButton, TextField } from '@mui/material';
import apiManagerSystem from 'api/manager-systems';
import { IconClose } from 'assets/icons';
import TextFieldVMP from 'components/common/TextField/TextFieldVMP';
import { TOAST_DEFAULT } from 'constants/toast';
import { Form, Formik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SwitchIOS from 'shared/components/base/SwitchIOS';
import { setCloseDialogCC, toastError, toastSuccess } from 'utils/helpers';
import * as yup from "yup";
import DialogBaseCC from './DialogBaseCC';
import { DIALOG_ID } from './constant';

const DialogAddUnit = () => {
    const propsDialog = useLegacyDialogProps();
    const open = useSelector((state) => state.dialog.open);
    const { t } = useTranslation()

    const { onSubmit, value, title = t('unit.header.addUnit'), actionButton = t('unit.button.addNew') } = propsDialog
    const formRef = useRef();
    const [selectUnit, setSelectUnit] = useState([])
    const [data, setData] = useState({
        value: '',
        code: '',
        unitId: null,
        active: true
    })

    const validationSchema = yup.object({
        value: yup.string().required(t('unit.helper.name')),
        code: yup
            .string()
            .required(t('unit.helper.code')),
        // unitId: yup
        //     .number().required(t('unit.helper.code'))
        //     .min(1, t('unit.helper.unit'))
        unitId: yup.object().shape({
            id: yup
                .number().required(t('unit.helper.code'))
                .min(1, t('unit.helper.unit'))
        })
    });

    const onConfirm = () => {
        if (formRef.current.isValid) {
            const { code, value, unitId, active } = formRef.current.values
            console.log("============> 123: ", unitId)
            if (title === t('unit.header.addUnit')) {
                apiManagerSystem.addUnit({
                    code: code.trim(),
                    name: value.trim(),
                    parent_unit_id: unitId?.id,
                    is_active: active ? 1 : 0
                })
                    .then((res) => {
                        if (res.message === "SUCCESS") {
                            toastSuccess(t('subTabHistorySystem.toast.createSuccess'));
                            if (onSubmit) {
                                onSubmit();
                            }
                            setCloseDialogCC()
                        } else {
                            if (res?.message === "UNIT CODE IS USED") {
                                toastError(t('unit.toast.existUnitCode'))
                            } else toastError(t('subTabHistorySystem.toast.createError'));
                        }
                    })
                    .catch((error) => {
                        if (error?.response?.data?.status === 403) {
                            toastError(t('unit.error.permission'));
                        } else toastError(t(TOAST_DEFAULT.ERROR));
                    });
            } else {
                apiManagerSystem.editUnit({
                    id: data.id,
                    code: code.trim(),
                    name: value.trim(),
                    parent_unit_id: unitId?.parentUnitId,
                    is_active: active ? 1 : 0
                })
                    .then((res) => {
                        if (res.message === "SUCCESS") {
                            toastSuccess(t('subTabHistorySystem.toast.updateSuccess'));
                            if (onSubmit) {
                                onSubmit();
                            }
                            setCloseDialogCC()
                        } else {
                            if (res.code === 6) {
                                toastError(t('unit.error.errorActive'))
                            } else toastError(t(TOAST_DEFAULT.ERROR));
                        }
                    })
                    .catch((error) => {
                        if (error?.response?.data?.status === 403) {
                            toastError(t('unit.error.permission'));
                        } else toastError(t(TOAST_DEFAULT.ERROR));
                    });
            }
        }
    }

    const apiGetTreeUnit = () => {
        return apiManagerSystem.getTree("MANAGE_UNIT_VIEW");
    }

    useEffect(() => {
        if (value) {
            setData({
                id: value.id,
                value: value.name,
                code: value.code,
                unitId: {...value.parent_unit_id, name: value.parent_unit_id.parentName},
                active: value.is_active === 1 ? true : false
            })
        }

        return () => {
            setData({
                id: "",
                value: "",
                code: "",
                unitId: "",
                active: true
            })
        }
    }, [value])

    useEffect(() => {
        if (open) {
            apiGetTreeUnit()
                .then(result => {
                    const fitlerResult = result?.data?.filter(value => value.in_scope === 1);
                    setSelectUnit(fitlerResult)
                })
                .catch(error => {

                })
                .finally(() => {

                })
        }
    }, [open])

    return (
        <DialogBaseCC id={DIALOG_ID.ADD_UNIT} title={title}>
            <DialogContent>
                <DialogContentText>
                    <Formik
                        innerRef={formRef}
                        enableReinitialize
                        initialValues={{
                            value: data.value,
                            code: data.code,
                            unitId: data.unitId,
                            active: data.active
                        }}
                        validationSchema={validationSchema}
                        onSubmit={onConfirm}
                    >{props => {
                        const {
                            values,
                            touched,
                            errors,
                            handleChange,
                            setFieldValue,
                            handleSubmit
                        } = props;
                        return (
                            <Form onSubmit={handleSubmit}>
                                <div className={'form-input'}>
                                    <div className={'label'}>{t('unit.label.unitCode')}<span className={'required'}>*</span></div>
                                    <TextFieldVMP
                                        placeholder={t('unit.placeholder.enterUnitCode')}
                                        autoFocus={true}
                                        shrink="true"
                                        fullWidth
                                        id="unitCode"
                                        name="code"
                                        value={values.code}
                                        onChange={handleChange}
                                        error={touched.code && Boolean(errors.code)}
                                        helperText={touched.code && errors.code}
                                        size="small"
                                        InputProps={
                                            values.code === '' ?
                                                {
                                                } :
                                                {
                                                    endAdornment: (
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() => setFieldValue('code', '')}
                                                            sx={{ p: 0.5 }}
                                                        ><IconClose /></IconButton>
                                                    )
                                                }
                                        }
                                    />
                                </div>
                                <div className={'form-input'}>
                                    <div className={'label'}>{t('unit.label.unitName')}<span className={'required'}>*</span></div>
                                    <TextFieldVMP
                                        placeholder={t('unit.placeholder.enterUnitName')}
                                        shrink="true"
                                        fullWidth
                                        id="unitName"
                                        name="value"
                                        value={values.value}
                                        onChange={handleChange}
                                        error={touched.value && Boolean(errors.value)}
                                        helperText={touched.value && errors.value}
                                        size="small"
                                        InputProps={
                                            values.value === '' ?
                                                {
                                                } :
                                                {
                                                    endAdornment: (
                                                        <IconButton
                                                            className={""}
                                                            aria-label="toggle password visibility"
                                                            onClick={() => setFieldValue('value', '')}
                                                            sx={{ p: 0.5 }}
                                                        ><IconClose /></IconButton>
                                                    )
                                                }
                                        }
                                    />
                                </div>
                                <div className={'form-input'} style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className={'label'}>{t('unit.label.parentUnit')}<span className={'required'}>*</span></div>
                                    <FormControl error={Boolean(errors.unitId) && touched.unitId}>
                                        {/* <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={values.unitId}
                                            onChange={(event) => { setFieldValue('unitId', event.target.value) }}
                                        >
                                            {
                                                selectUnit.map((item, index) => {
                                                    return (
                                                        <MenuItem value={item.id}>{item.name}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select> */}
                                        <Autocomplete
                                            noOptionsText={t('search.notfound')}
                                            value={values.unitId}
                                            onChange={(event, newValue) => {
                                                setFieldValue('unitId', newValue)
                                            }}
                                            options={selectUnit}
                                            getOptionLabel={(option) => option.name || ""}
                                            renderInput={(params) => <TextField {...params} placeholder={t('unit.placeholder.enterUpperUnitName')}/>}
                                            clearIcon={
                                                <IconClose />
                                            }
                                        />
                                        {
                                            Boolean(errors.unitId) && touched.unitId
                                            && <FormHelperText sx={{fontSize: '14px'}}>{t('unit.helper.unit')}</FormHelperText>
                                        }
                                    </FormControl>
                                </div>
                                <Box sx={{ marginTop: '16px' }}>
                                    <div className={'label'}>{t('unit.label.status')}</div>
                                    <SwitchIOS checked={values.active} onChange={(e) => { setFieldValue('active', e.target.checked) }} />
                                </Box>
                            </Form>
                        )
                    }}
                    </Formik>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={setCloseDialogCC}>{t('dialog.cancel')}</Button>
                <Button type='submit' onClick={() => { formRef.current.handleSubmit() }} >{actionButton}</Button>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogAddUnit